<script>
    import {PATH_PREFIX} from '../../../../apiUrls.js';
    import { sgettext } from '../../../../i18n.js';
    import { submit } from '../../../../utils.js';
    import MediaInput from '../../../common/Media/MediaInput.svelte';
    import Thumbnail from '../../../common/Media/Thumbnail.svelte';
    import MegaSelect from '../../../MegaSelect/MegaSelect.svelte';
    import {writable} from 'svelte/store';
  import { loop } from 'svelte/internal';
    export let activityVersionId;
    export let item = null;
    export let fields;
    export let editable = true;
    export let retrieveItems;
    export let retrievedItems;
    export let actionUrl;
    export let id = '';
    export let key = '';
    export let dropAreaStyle = '';
    export const selectedMedia = writable(null);
    export const targetItem = writable(null);
    export const elementVersionEntity = writable(null);
    export let row = null;
    export let mediaLibraryId = '';
    export let entity = null;
    export let useMediaLibrary = true;
    let selectedAlpha = '';
    let isWaiting = false;
    let mediaInput;
    let mediaError = null;
    export let width = '160px';
    export let height = '90px';
    export let onChange = () => {
    };
  
    const validFileTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif"
    ]
    const alpha = Array.from(Array(26)).map((e, i) => i + 65);
    //map to this array of object to work with the already existing megaSelect component
    let alphabet = alpha.map((x) => ({"id":String.fromCharCode(x), "value":String.fromCharCode(x)}));
    //uncertain if this is the most optimal implementation.
    for (const appendix of retrievedItems) {
        alphabet = alphabet.filter(alphaObject => alphaObject.id != appendix.alpha);

    }

    export let media = null;
    export let updateMedia = null
  
    // Creating
    export let isCreating = false;
    let createValues = {name: '', description: '', count: null};
    let cancelCreatingMode = () => {
      isWaiting = false;
      isCreating = false;
    };
    $: isValidCreateForm = (createValues.name && selectedAlpha && media && media?.size < 100*(1024**2) && (validFileTypes.includes(media.type))? true : false);
  
  
  
    async function handleContextualMediaChange(media) {
          if (media) {
              const url = `${PATH_PREFIX}/sw/v2/api/activity_version/${activityVersionId}/appendix/upload/`;
              const formData = new FormData();
              const metadata = {
                  chunkIndex: 1,
                  totalChunks: 1,
                  contentType: media.type,
                  totalFileSize: media.size,
                  fileName: media.name,
  
              };
              formData.append('files', media);
              formData.append('metadata', JSON.stringify(metadata));
              formData.append('activity_version_id',activityVersionId)
              mediaError = null;
  
              const resp = await submit(url, 'POST', formData, null, true);
              if (resp.ok) {
                  const json = await resp.json();
                  console.log(json)
                  return json
              } else {
                  mediaError = sgettext('$$ERROR_OCCURRED$$');
              }
          }
      }
  
    async function addItem() {
        
        if(media.size > 100*(1024**2)) return;
        let upload_response = await handleContextualMediaChange(media) 

        let payload = {
            name: createValues.name,
            description: createValues.description,
            alpha: selectedAlpha.id,
            activity_version:activityVersionId,
            file_name:media.name,
            location:upload_response.location,
        };


        isWaiting = true;
        const response = await submit(actionUrl, 'POST', payload);

        if (response.ok) {
            await retrieveItems()
            cancelCreatingMode();
        }
    }
  
    // Editing
    let isEditing = false;
    let toEditItem = null;
    let editValues = {name: '', description: '', alpha: ''};

    let setEditingMode = item => {
      if (editable) {
        console.log(item)
        isEditing = true;
        toEditItem = {
          id: item.id,
          name: item.name,
          description: item.description,
          selectedAlpha:{ id: item.alpha, value: item.alpha },
        };
        editValues = {...toEditItem};
      }
    };
    let cancelEditingMode = () => {
      isWaiting = false;
      isEditing = false;
      toEditItem = null;
      updateMedia = null
      editValues = {name: '', description: '', alpha: ''};
    };

    $: isValidEditForm = (editValues.name && editValues.selectedAlpha && media && media?.size < 100*(1024**2) && (validFileTypes.includes(media.type))? true : false);
  
    async function updateItem(item) {

        let payload = {
            name: editValues.name,
            description: editValues.description,
            alpha: editValues.selectedAlpha.value,
            activity_version:activityVersionId,
            file_name:item.file_name,
            location:item.location,
        };

      if(media){
        let upload_response = await handleContextualMediaChange(media) 
        console.log(upload_response)
        payload.location=upload_response.location
        payload.file_name = media.name
      }
      

  
      isWaiting = true;
      const url = `${actionUrl}${item.id}/`;
      const response = await submit(url, 'PUT', payload);
  
      if (response.ok) {
        await retrieveItems();
        cancelEditingMode();
      }
    }
  
    // Deleting
    export let isDeleting = false;
    export let toDeleteItem = null;
    let tryToDelete = (item=null) => {
      if (item) {
        isDeleting = true;
        toDeleteItem = {
          id: item.id,
          name: item.name,
          //TODO: these are wrong. somehow some modal is looking for a value named conut. i dont know what
          //presumably i would need to find it and make a new one that uses alpha instead of count.
          description: item.alpha,
          count: item.description
        };
      }
    };
</script>

{#if isCreating}
  <tr>
    <td>
      <!-- svelte-ignore a11y-autofocus -->
      <input
        type="text"
        class="form-control"
        placeholder={`${fields[0]}*`}
        bind:value={createValues.name}
        autofocus={true}
        readonly={isWaiting}
      />
    </td>
    <td>
      <MegaSelect
        id="alphaSelection"
        options={alphabet}
        placeholder={sgettext('$$SEARCHSELECT_$$')}
        noOptionsMessage={sgettext('$$OPTIONS$$')}
        itemValueKey="id"
        itemLabelKey="value"
        itemDescriptionKey="description"
        showDescriptions={false}
        showImages={false}
        listAutoWidth={true}
        centerItems={true}
        bind:selectedItem={selectedAlpha}
      />
    </td>
    <td>
      <input
        type="text"
        class="form-control"
        placeholder={fields[2]}
        bind:value={createValues.description}
        readonly={isWaiting}
      />
    </td>
    <td>
      <MediaInput
        bind:this={mediaInput}
        {id}
        {key}
        bind:media
        {width}
        {height}
        {onChange}
        useMediaLibrary={false}
        showLibrary={() => mediaInput.showFileBrowser()}
        {dropAreaStyle}
      />
        {#if media && !validFileTypes.includes(media?.type)}
            {sgettext("$$MP4_FILES_NOT_ACCEPTED$$")}
        {/if}
        {#if media && media?.size > 100*(1024**2)}
            {sgettext("$$FILES_MUST_SMALLER_100MB$$")}
        {/if}

    </td>
    <td class="actions">
      <button
        class="btn btn-sm btn-primary mr-2"
        on:click={addItem}
        disabled={!isValidCreateForm || isWaiting}
      >
        {#if isWaiting}
          {sgettext('$$ADDING_$$')}
        {:else}
          {sgettext('$$ADD_1$$')}
        {/if}
      </button>
      {#if isWaiting}
        <div class="d-inline-block mx-2">
          <div
            class="spinner-border spinner-border-sm text-primary"
            role="status"
          >
            <span class="sr-only">{sgettext('$$LOADING$$')}...</span>
          </div>
        </div>
      {:else}
        <button class="btn btn-sm btn-outline" on:click={cancelCreatingMode}>
          {sgettext('$$CANCEL$$')}
        </button>
      {/if}
      <button class="btn btn-sm btn-outline" on:click={()=>(media=null)} disabled={!media}>
        {sgettext("$$CLEAR_MEDIA$$")}
      </button>
    </td>
  </tr>
{:else if isEditing && item?.id && toEditItem?.id && item.id === toEditItem.id}
  <tr>
    <td>
      <!-- svelte-ignore a11y-autofocus -->
      <input
        type="text"
        class="form-control"
        placeholder={`${fields[0]}*`}
        bind:value={editValues.name}
        autofocus={true}
        readonly={isWaiting}
      />
    </td>
    <td>
      <MegaSelect
        id="alphaSelection"
        options={[{ id: item.alpha, value: item.alpha }, ...alphabet]}
        placeholder={sgettext('$$SEARCHSELECT_$$')}
        noOptionsMessage={sgettext('$$OPTIONS$$')}
        itemValueKey="id"
        itemLabelKey="value"
        itemDescriptionKey="description"
        showDescriptions={false}
        showImages={false}
        listAutoWidth={true}
        centerItems={true}
        bind:selectedItem={editValues.selectedAlpha}
      />
    </td>
    <td>
      <input
        type="text"
        class="form-control"
        placeholder={fields[2]}
        bind:value={editValues.description}
        readonly={isWaiting}
      />
    </td>
    <td>
      <MediaInput
        bind:this={mediaInput}
        {id}
        {key}
        bind:media
        {width}
        {height}
        {onChange}
        useMediaLibrary={false}
        showLibrary={() => mediaInput.showFileBrowser()}
        {dropAreaStyle}
      />
    {#if media && !validFileTypes.includes(media?.type)}
    {sgettext("$$MP4_FILES_NOT_ACCEPTED$$")}
    {/if}
    {#if media && media?.size > 100*(1024**2)}
    {sgettext("$$FILES_MUST_SMALLER_100MB$$")}
    {/if}
    </td>
    <td class="actions">
      <button
        class="btn btn-sm btn-primary mr-2"
        on:click={() => updateItem(item)}
        disabled={!isValidEditForm || isWaiting}
      >
        {#if isWaiting}
          {sgettext('$$UPDATING_$$')}
        {:else}
          {sgettext('$$UPDATE_1$$')}
        {/if}
      </button>
      {#if isWaiting}
        <div class="d-inline-block mx-2">
          <div
            class="spinner-border spinner-border-sm text-primary"
            role="status"
          >
            <span class="sr-only">{sgettext('$$LOADING$$')}...</span>
          </div>
        </div>
      {:else}
        <button class="btn btn-sm btn-outline" on:click={cancelEditingMode}>
          {sgettext('$$CANCEL$$')}
        </button>
      {/if}
      <button class="btn btn-sm btn-outline" on:click={()=>(media=null)} disabled={!media}>
        {sgettext("$$CLEAR_MEDIA$$")}
      </button>
    </td>
  </tr>
{:else if item?.id}
  <tr>
    <td>{item.name}</td>
    <td class="alpha">{item.alpha}</td>
    <td>{item.description}</td>
    <td>
      <Thumbnail
        url="/{item.location}appendix_media_thumbnail.jpg"
        media="/{item.location}appendix_media.jpg"
        name={sgettext('$$APPENDIX_MEDIA$$')}
      />
    </td>

    {#if editable}
      <td class="actions">
        {#if !isEditing && !isCreating}
          <span on:click={() => setEditingMode(item)}>
            <i class="fas fa5-edit" />
          </span>
          <span on:click={() => tryToDelete(item)}>
            <i class="fas fa5-trash-alt" />
          </span>
        {/if}
      </td>
    {/if}
  </tr>
{/if}

<style>
  .alpha {
    text-align: center;
  }

  .actions {
    text-align: right;
    min-width: 130px;
    white-space: nowrap;
  }

  .actions i {
    margin: 0 0 0 20px;
    cursor: pointer;
  }
</style>
